import script from "./AnnouncementModalBody.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementModalBody.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementModalBody.vue?vue&type=style&index=0&id=23266fec&lang=scss"

export default script